"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getListPluginCss = void 0;
/** li ol css in getDefaultCss.ts */
const getListPluginCss = (themeId, isPreviewer) => {
    if (!isPreviewer) {
        return `.${themeId} .list-parent{
      padding: 1rem;
    }`;
    }
    return "";
};
exports.getListPluginCss = getListPluginCss;
